import { Component, Input, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { NotificationTheme, NotificationLayout } from '@fcom/ui-components';
import { FrequentFlyerTierLevel } from '@fcom/common-booking/interfaces/utils.interface';

@Component({
  selector: 'fin-mmb-tier-benefits',
  templateUrl: 'tier-benefits.component.html',
  styleUrls: ['../../../../../common-booking/assets/helper-classes.scss', './tier-benefits.component.scss'],
  standalone: false,
})
export class ManageBookingTierBenefitsComponent implements OnInit {
  readonly NotificationTheme = NotificationTheme;
  readonly NotificationLayout = NotificationLayout;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  @Input() tierBenefits: string[];
  @Input() tierLevel: string;
  @Input() tier: FrequentFlyerTierLevel;
  baseTranslation = '';

  ngOnInit(): void {
    this.baseTranslation = this.getBaseTranslation(this.tier);
  }

  getBaseTranslation(tier: FrequentFlyerTierLevel): string {
    switch (tier) {
      case FrequentFlyerTierLevel.PLUS:
        return 'MMB.tierBenefits.basic';
      case FrequentFlyerTierLevel.SILVER:
        return 'MMB.tierBenefits.silver';
      case FrequentFlyerTierLevel.GOLD:
        return 'MMB.tierBenefits.gold';
      case FrequentFlyerTierLevel.PLATINUM:
        return 'MMB.tierBenefits.platinum';
      case FrequentFlyerTierLevel.LUMO:
        return 'MMB.tierBenefits.lumo';
      case FrequentFlyerTierLevel.JUNIOR:
        return 'MMB.tierBenefits.junior';
      default:
        return undefined;
    }
  }
}
